export default {
  // Common
  save: "Save",
  cancel: "Cancel",
  loading: "Loading...",
  inactive: "Inactive",
  active: "Active",
  edit: "Edit",
  delete: "Delete",
  name: "Name",
  email: "Email",
  description: "Description",
  date: "Date",
  time: "Time",
  status: "Status",
  notes: "Notes",
  close: "Close",
  language: "Language",

  // Auth
  auth_welcome: "Welcome back",
  auth_create: "Create account",
  auth_signin_sub: "Sign in to your dashboard",
  auth_create_sub: "Set up your booking system",
  auth_business_name: "Business name",
  auth_business_placeholder: "Your business name",
  auth_email_placeholder: "admin@business.com",
  auth_password: "Password",
  auth_password_placeholder: "Enter password",
  auth_signing_in: "Loading...",
  auth_toggle_login: "Already have an account? Sign in",
  auth_toggle_register: "Need an account? Create one",
  auth_success_register: "Account created",
  auth_success_login: "Welcome back!",
  auth_error: "Authentication failed",
  auth_email_invalid: "Please enter a valid email address",
  auth_forgot_password: "Forgot your password?",
  auth_password_confirm: "Confirm password",
  auth_password_confirm_placeholder: "Re-enter your password",
  auth_password_mismatch: "Passwords do not match",

  // Forgot password
  forgot_title: "Forgot password",
  forgot_sub: "Enter your email address and we'll send you a reset code.",
  forgot_send: "Send reset code",
  forgot_sent_title: "Check your email",
  forgot_sent_sub: "We sent a 6-digit code to your email address. It expires in 30 minutes.",
  forgot_enter_code: "Enter the code",
  forgot_back_login: "Back to login",

  // Reset password
  reset_title: "Reset password",
  reset_sub: "Enter the 6-digit code from your email and choose a new password.",
  reset_code_label: "Reset code",
  reset_new_password: "New password",
  reset_password_placeholder: "Min. 4 characters",
  reset_password_hint: "Minimum 4 characters",
  reset_password_min: "Password must be at least 4 characters",
  reset_invalid_code: "Invalid or expired code",
  reset_submit: "Reset password",
  reset_done_title: "Password updated!",
  reset_done_sub: "Your password has been changed. You can now sign in.",

  // Sidebar
  nav_dashboard: "Dashboard",
  nav_services: "Services",
  nav_staff: "Staff",
  nav_appointments: "Appointments",
  nav_calendar: "Calendar",
  nav_settings: "Settings",
  nav_widget: "Widget",
  nav_logout: "Log out",

  // Dashboard
  dashboard_title: "Dashboard",
  dashboard_loading: "Loading dashboard...",
  dashboard_today: "Today",
  dashboard_total: "Total Bookings",
  dashboard_pending: "Pending",
  dashboard_services: "Services",
  dashboard_todays_schedule: "Today's Schedule",
  dashboard_upcoming: "Upcoming",
  dashboard_view_all: "View all",
  dashboard_no_today: "No appointments today",
  dashboard_no_upcoming: "No upcoming appointments",

  // Services
  services_title: "Services",
  services_add: "Add Service",
  services_empty: "No services yet",
  services_empty_sub: "Create your first service to start accepting bookings",
  services_new: "New Service",
  services_edit: "Edit Service",
  services_new_sub: "Create a new bookable service",
  services_edit_sub: "Update your service details",
  services_name_placeholder: "e.g. Haircut",
  services_desc_placeholder: "Brief description",
  services_duration: "Duration",
  services_price: "Price",
  services_buffer: "Buffer time",
  services_color: "Color",
  services_name_required: "Service name is required",
  services_created: "Service created",
  services_updated: "Service updated",
  services_deleted: "Service deleted",
  services_load_error: "Failed to load services",
  services_save_error: "Failed to save",
  services_delete_error: "Failed to delete",
  services_delete_confirm_title: "Delete service",
  services_delete_confirm_sub: "Are you sure you want to delete {{name}}? This action cannot be undone.",
  services_translations: "Translations",
  services_trans_name_placeholder: "Service name in this language",
  services_trans_desc_placeholder: "Description in this language (optional)",

  // Staff
  staff_title: "Staff",
  staff_add: "Add Staff",
  staff_empty: "No staff members yet",
  staff_empty_sub: "Add staff so customers can choose who to book with",
  staff_new: "Add Staff",
  staff_edit: "Edit Staff",
  staff_new_sub: "Add a new team member",
  staff_edit_sub: "Update staff details",
  staff_email_optional: "Email (optional)",
  staff_email_placeholder: "john@example.com",
  staff_name_placeholder: "e.g. John Smith",
  staff_name_required: "Name is required",
  staff_created: "Staff added",
  staff_updated: "Staff updated",
  staff_deleted: "Staff removed",
  staff_load_error: "Failed to load staff",
  staff_save_error: "Failed to save",
  staff_delete_error: "Failed to delete",
  staff_delete_confirm_title: "Delete staff member",
  staff_delete_confirm_sub: "Are you sure you want to delete {{name}}? This action cannot be undone.",

  // Appointments
  appointments_title: "Appointments",
  appointments_search: "Search by name, email, or service...",
  appointments_filter_all: "All",
  appointments_filter_confirmed: "Confirmed",
  appointments_filter_pending: "Pending",
  appointments_filter_cancelled: "Cancelled",
  appointments_none: "No appointments found",
  appointments_customer: "Customer",
  appointments_service: "Service",
  appointments_staff: "Staff",
  appointments_edit: "Edit",
  appointments_confirm: "Confirm",
  appointments_cancel: "Cancel",
  appointments_delete: "Delete",
  appointments_edit_title: "Edit Appointment",
  appointments_edit_sub: "Update appointment details",
  appointments_notes_placeholder: "Add notes...",
  appointments_status_updated: "Status updated to {{status}}",
  appointments_load_error: "Failed to load",
  appointments_status_error: "Failed to update status",
  appointments_update_error: "Failed to update",
  appointments_delete_error: "Failed to delete",
  appointments_updated: "Appointment updated",
  appointments_deleted: "Appointment deleted",

  // Calendar
  calendar_title: "Calendar",
  calendar_today: "Today",
  calendar_reschedule_ok: "Rescheduled",
  calendar_reschedule_err: "Failed to reschedule",
  calendar_load_error: "Failed to load appointments",

  // Settings
  settings_title: "Settings",
  settings_save: "Save Changes",
  settings_saving: "Saving...",
  settings_business_info: "Business Information",
  settings_business_name: "Business Name",
  settings_business_desc: "Description",
  settings_business_desc_placeholder: "Brief description of your business",
  settings_booking_url: "Booking URL",
  settings_working_hours: "Working Hours",
  settings_hours_to: "to",
  settings_widget_appearance: "Widget Appearance",
  settings_primary_color: "Primary Color",
  settings_accent_color: "Accent Color",
  settings_saved: "Settings saved",
  settings_save_error: "Failed to save",
  settings_load_error: "Failed to load settings",
  settings_link_copied: "Booking link copied!",
  settings_approval_title: "Booking Approval",
  settings_approval_sub: "Automatically confirm pending bookings if not reviewed within the selected time.",
  settings_approval_off: "Off — manual approval only",
  settings_approval_30m: "After 30 minutes",
  settings_approval_1h: "After 1 hour",
  settings_approval_2h: "After 2 hours",
  settings_approval_6h: "After 6 hours",
  settings_approval_12h: "After 12 hours",
  settings_approval_active: "Bookings auto-confirm after {{hours}}h",
  settings_approval_inactive: "Auto-approval is off",

  // Widget Preview
  widget_preview_title: "Booking Widget",
  widget_preview_open: "Open Widget",
  widget_preview_loading: "Loading your booking link...",
  widget_preview_embed: "Embed Code",
  widget_preview_live: "Live Preview",
  widget_preview_embed_hint: "Copy and paste this code into your website to embed the booking widget.",
  widget_preview_copied: "Copied to clipboard",

  // Booking Widget (customer-facing)
  booking_book_appointment: "Book Appointment",
  booking_not_found: "Business not found.",
  booking_not_found_sub: "Please check the booking link and try again.",
  booking_step_service: "Service",
  booking_step_staff: "Staff",
  booking_step_datetime: "Date & Time",
  booking_step_details: "Details",
  booking_choose_service: "Choose a service",
  booking_no_services: "No services available",
  booking_choose_staff: "Choose a staff member",
  booking_any_staff: "Any available",
  booking_any_staff_sub: "We'll assign the first available staff",
  booking_pick_datetime: "Pick date & time",
  booking_available_times: "Available times for {{date}}",
  booking_no_slots: "No slots available for this date",
  booking_continue: "Continue",
  booking_your_details: "Your details",
  booking_name: "Name *",
  booking_email: "Email *",
  booking_phone: "Phone",
  booking_name_placeholder: "Your full name",
  booking_email_placeholder: "your@email.com",
  booking_phone_placeholder: "Phone number",
  booking_confirm: "Confirm Booking",
  booking_confirming: "Booking...",
  booking_pending_title: "Request Received!",
  booking_pending_sub: "We'll send you an email once your appointment is confirmed.",
  booking_success_title: "Booking Confirmed!",
  booking_success_sub: "Your appointment has been scheduled",
  booking_service_label: "Service",
  booking_date_label: "Date",
  booking_time_label: "Time",
  booking_another: "Book another appointment",
  booking_failed: "Booking failed. Please try again.",
  booking_gdpr_text: "I agree that my personal data (name, email, phone number) will be processed solely for the purpose of managing this booking, in accordance with applicable data protection regulations (nDSG/GDPR). My data will not be shared with third parties.",
  booking_select_hint: "Select one or more services",
  booking_available: "Available",
  booking_unavailable: "Unavailable",
  booking_email_invalid: "Please enter a valid email address",
};
